<template>
  <el-form-item :label="name" :required="getRequire">
    <el-tooltip :disabled="tips==='' || tips===null || tips===undefined" class="item" effect="dark" :content="tips" placement="top">

      <el-date-picker
        v-model="val"
        align="right"
        type="date"
        :class="{'require':getRequire && isNull()}"
        size="small"
        :disabled="disabled"
        placeholder="选择日期"
        :format="format"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        @change="change"
      />
    </el-tooltip>
    <el-tooltip v-if="errorSign" class="right" effect="dark" :content="message" placement="top">
      <div>
        <i class="el-icon-warning" style="color:red;" />
      </div>
    </el-tooltip>
  </el-form-item>
</template>

<script>
import { toDate } from '@/utils/ik/conversion/date'
import { verify } from '@/utils/ik/verify/verify.js'
export default {
  name: 'IkFormDate',
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'change'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    },
    i: {
      type: String,
      default: '99'
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [
        ]
      }
    }
  },
  data() {
    return {
      val: '',
      defaultVal: '',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }]
      },
      errorSign: false,
      message: ''
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  watch: {
    value: {
      handler(value, oldValue) {
        if (this.value !== '') {
          this.val = value
        } else {
          if (this.defaultValue.indexOf('Now') !== -1) {
            this.defaultVal = toDate(this.defaultValue, this.format)
          } else {
            this.defaultVal = this.defaultValue
          }
          this.val = this.defaultVal
        }
        this.change(this.val)
      },
      immediate: true
    }
  },
  // 如果value为空，取默认值
  created() {
    this.change(this.value)
  },
  methods: {
    change(value) {
      // 取值验证
      // v-model实现触发方法
      if (value === null) {
        value = ''
      }
      // 取值验证
      this.message = verify(value, this.rules)
      this.errorSign = this.message !== null
      // 空值验证
      if (this.getRequire && this.isNull()) {
        this.errorSign = true
        this.message = "必填项，不可为空"
      }
      this.$emit('onFieldChange', this.code, '', value, this.errorSign, this.message)
      this.$emit('change', value)
    },
    isNull() {
      return this.val === '' || this.val === null || this.val === undefined
    },
    reset() {
      this.value = this.defaultValue
    },
    clean() {
      const date = new Date()
      date.getTime()
      this.value = date
    }
  }
}
</script>
<style scoped>
::v-deep.require> .el-input__inner{
  border: red 1px solid;
}
.item.el-date-editor.el-input{width:calc(100% - 30px)}
</style>
<style lang="scss" >

.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}
.el-date-editor.el-input {
  width: 100%;
}
.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
